const authConfig = {
    // authority: 'https://dev-4324571.okta.com', //Replace with your issuer URL
    // client_id: '0oa2qdz4kmTsO26BI5d6', //Replace with your client id
    // redirect_uri: 'http://localhost:3000/callback',
    // response_type: 'code',
    // scope: 'openid email profile offline_access',
    // post_logout_redirect_uri: 'https://snook-uat.basspro.com/bluefletch_login/OidcEndSession.aspx',
    // userinfo_endpoint: 'https://snook-uat.basspro.com/bluefletch_login/OidcToken.aspx', //Replace with your user-info endpoint
    // response_type: 'code',
    // code_challenge_method: 'S256',
    // apiUrl: "http://localhost:8080",
    // urlOrigin : "http://localhost:3000"

    PROD : {
      authority: 'https://login.microsoftonline.com/035c9b6a-9ba7-4804-a377-482ed2642e72', //Replace with your issuer URL
      client_id: '26e2bf78-a594-4b39-a573-b37a3e80b938', //Replace with your client id
      redirect_uri: 'https://basspro.bluefletch.com/callback',
      response_type: 'code',
      scope: 'openid email profile offline_access ',
      response_mode: 'query',
      code_challenge_method: 'S256'
    },

    PROD_BSB : {
      authority: 'https://login.microsoftonline.com/ef9d14d2-4d7e-4945-b082-15926b1ac472', //Replace with your issuer URL
      client_id: '0aae232b-e632-49c9-9734-91f44db35cb5', //Replace with your client id
      redirect_uri: 'http://localhost:8080/callback',
      response_type: 'code',
      scope: 'openid email profile offline_access ',
      response_mode: 'query',
      code_challenge_method: 'S256'
    },

    STAGING : {
      authority: 'https://login.microsoftonline.com/ef9d14d2-4d7e-4945-b082-15926b1ac472', //Replace with your issuer URL
      client_id: '0aae232b-e632-49c9-9734-91f44db35cb5', //Replace with your client id
      redirect_uri: 'http://localhost:8080/callback',
      response_type: 'code',
      scope: 'openid email profile offline_access ',
      response_mode: 'query',
      code_challenge_method: 'S256'
    }

    // authority: 'https://instance1-op828f.zitadel.cloud', //Replace with your issuer URL
    // client_id: '267892376259896695@project1', //Replace with your client id
    // redirect_uri: 'https://oidc-web-nxfeydaxva-uc.a.run.app/callback',
    // response_type: 'code',
    // scope: 'openid email profile offline_access ',
    // post_logout_redirect_uri: 'https://oidc-web-nxfeydaxva-uc.a.run.app',
    // userinfo_endpoint: 'https://instance1-op828f.zitadel.cloud/oidc/v1/userinfo', //Replace with your user-info endpoint
    // response_mode: 'query',
    // code_challenge_method: 'S256',

    //Dev
    // authority: 'https://instance1-op828f.zitadel.cloud', //Replace with your issuer URL
    // client_id: '267892376259896695@project1', //Replace with your client id
    // redirect_uri: 'http://localhost:8080/callback',
    // response_type: 'code',
    // scope: 'openid email profile offline_access ',
    // post_logout_redirect_uri: 'http://localhost:8080',
    // userinfo_endpoint: 'https://instance1-op828f.zitadel.cloud/oidc/v1/userinfo', //Replace with your user-info endpoint
    // response_mode: 'query',
    // code_challenge_method: 'S256',
  };

 export default authConfig;